/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ChangePasswordWithTokenInput = {
    token: string;
    password: string;
    clientMutationId?: string | null | undefined;
};
export type ChangePasswordWithTokenMutationVariables = {
    input: ChangePasswordWithTokenInput;
};
export type ChangePasswordWithTokenMutationResponse = {
    readonly changePasswordWithToken: {
        readonly success: boolean | null;
    } | null;
};
export type ChangePasswordWithTokenMutation = {
    readonly response: ChangePasswordWithTokenMutationResponse;
    readonly variables: ChangePasswordWithTokenMutationVariables;
};



/*
mutation ChangePasswordWithTokenMutation(
  $input: ChangePasswordWithTokenInput!
) {
  changePasswordWithToken(input: $input) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangePasswordWithTokenPayload",
    "kind": "LinkedField",
    "name": "changePasswordWithToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePasswordWithTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangePasswordWithTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "31fdeb83b1faba5410fb233c483f526f",
    "id": null,
    "metadata": {},
    "name": "ChangePasswordWithTokenMutation",
    "operationKind": "mutation",
    "text": "mutation ChangePasswordWithTokenMutation(\n  $input: ChangePasswordWithTokenInput!\n) {\n  changePasswordWithToken(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '338089ca9c83c95d1206221ce836044c';
export default node;
